import { handleActions, createAction } from 'redux-actions';
import pick from 'lodash/pick';

export const FETCH_USER_DATA = createAction('FETCH/USER/DATA');
export const FETCH_USER_DATA_SUCCESS = createAction('FETCH/USER/DATA/SUCCESS');
export const FETCH_USER_DATA_FAIL = createAction('FETCH/USER/DATA/FAIL');
export const CHANGE_USER_DATA = createAction('CHANGE/USER/DATA');
export const CHANGE_USER_DATA_SUCCESS = createAction('CHANGE/USER/DATA/SUCCESS');
export const CHANGE_USER_DATA_FAIL = createAction('CHANGE/USER/DATA/FAIL');
export const CHANGE_USER_PASSWORD = createAction('CHANGE/USER/PASSWORD');
export const CHANGE_USER_PASSWORD_SUCCESS = createAction('CHANGE/USER/PASSWORD/SUCCESS');
export const CHANGE_USER_PASSWORD_FAIL = createAction('CHANGE/USER/PASSWORD/FAIL');
export const SIGN_OUT = createAction('SIGN_OUT');
export const SIGN_OUT_SUCCESS = createAction('SIGN_OUT/SUCCESS');
export const SIGN_OUT_FAIL = createAction('SIGN_OUT/FAIL');

const initialState = {
  company_name: '',
  first_name: '',
  ftin: '',
  last_name: '',
  nickname: '',
  phone: '',
  place: '',
  street: '',
  zip_code: '',
  second_phone: '',
  avatar: '',
  avatar_thumb: '',
  new_app_user: false,
  email: '',
  fetchUserDataErrors: null,
  changeUserDataErrors: null,
  changeUserPasswordErrors: null,
};

const userDataReducer = handleActions(
  {
    [FETCH_USER_DATA_SUCCESS]: (state, { payload: data, }) => {
      const newData = pick(data, [
        'company_name', 'first_name', 'ftin', 'last_name', 'id', 'new_app_user',
        'nickname', 'phone', 'second_phone', 'email', 'place', 'street', 'zip_code'
      ]);

      return { ...state,
        ...newData,
        avatar: data.avatar_url,
        avatar_thumb: data.avatar_thumb_url, };
    },
    [FETCH_USER_DATA_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, fetchUserDataErrors: error, };
    },
    [CHANGE_USER_DATA_SUCCESS]: (state, { payload: { userData, }, }) => {
      const newData = pick(userData, [
        'company_name', 'first_name', 'ftin', 'last_name', 'nickname',
        'phone', 'second_phone', 'email', 'place', 'street', 'zip_code'
      ]);

      return { ...state,
        ...newData,
        avatar: userData.avatar.url,
        avatar_thumb: userData.avatar.thumb.url, };
    },
    [CHANGE_USER_DATA_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, changeUserDataErrors: error, };
    },
    [CHANGE_USER_PASSWORD_SUCCESS]: (state, { payload: { data, }, }) => {
      return { ...state, data, };
    },
    [CHANGE_USER_PASSWORD_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, changeUserPasswordErrors: error, };
    },
    [SIGN_OUT_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, signOutErros: error, };
    },
  },
  initialState
);

export default userDataReducer;
